<ion-card>
  <ion-card-header>
    <ion-card-title>Tantárgyi felmentések</ion-card-title>
    <ion-card-subtitle>
      A felmentés nem csak nyilvántartás: az <b>óralátogatás alóli</b> felmentésnél a tanuló sora a naplóban
      kiszürkül és nem írható be hiányzónak, a szülői/tanulói órarendből pedig eltűnik az óra. Az
      <b>értékelés alóli</b> felmentés a névsorban jelenik meg a tanárnak. Ami a KRÉTÁ-ból jött, az alul
      látszik – átvéve itt is szerkeszthetővé válik.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <div class="felm-fejsor">
      <ion-select label="Osztály" label-placement="stacked" interface="popover" style="min-width:160px"
                  [(ngModel)]="szuroOsztaly" (ionChange)="betolt()">
        <ion-select-option value="">Mind</ion-select-option>
        <ion-select-option *ngFor="let o of osztalyok" [value]="o.id">{{ o.osztaly }}</ion-select-option>
      </ion-select>
      <ion-searchbar class="felm-kereso" placeholder="Tanuló, tantárgy, ok, határozat…" mode="md"
                     [(ngModel)]="kereses" (ionChange)="betolt()" [debounce]="400"></ion-searchbar>
      <ion-toggle [(ngModel)]="mind" (ionChange)="betolt()" labelPlacement="end">Lejártak és töröltek is</ion-toggle>
      <ion-button size="small" (click)="ujFelmentes()">
        <ion-icon slot="start" name="add-outline"></ion-icon>Új felmentés
      </ion-button>
      <ion-button size="small" fill="outline" (click)="betolt()" [disabled]="toltodik">
        <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
      </ion-button>
    </div>

    <p *ngIf="hiba" style="color:var(--ion-color-danger)">{{ hiba }}</p>

    <!--  RÖGZÍTŐ ŰRLAP. Az „mi alól mentesül" nem elhagyható: a napló ebből dönt. -->
    <div class="felm-urlap" *ngIf="urlapNyitva">
      <h4>{{ szerkesztettId ? 'Felmentés módosítása' : 'Új felmentés' }}</h4>
      <div class="felm-mezok">
        <ion-select label="Tanuló" label-placement="stacked" interface="alert" [interfaceOptions]="{ cssClass: 'nagy' }"
                    [(ngModel)]="urlap.oktazon" (ionChange)="tanuloValt()">
          <ion-select-option *ngFor="let t of tanulok" [value]="t.oktazon">
            {{ t.nev }}{{ t.osztaly_nev ? ' – ' + t.osztaly_nev : '' }}
          </ion-select-option>
        </ion-select>
        <ion-select label="Tantárgy" label-placement="stacked" interface="alert" [interfaceOptions]="{ cssClass: 'nagy' }"
                    [(ngModel)]="urlap.tantargy" (ionChange)="tantargyValt()">
          <ion-select-option value="">Minden tantárgy (általános felmentés)</ion-select-option>
          <ion-select-option *ngFor="let t of tantargyak" [value]="t.id">{{ t.name }}</ion-select-option>
        </ion-select>
        <ion-input label="Kezdete" label-placement="stacked" type="date" [(ngModel)]="urlap.kezdete"></ion-input>
        <ion-input label="Vége (üres = visszavonásig)" label-placement="stacked" type="date"
                   [(ngModel)]="urlap.vege"></ion-input>
        <ion-input label="Határozat / iktatószám" label-placement="stacked" [(ngModel)]="urlap.hatarozat"></ion-input>
        <ion-input label="A felmentés oka" label-placement="stacked" [(ngModel)]="urlap.ok"></ion-input>
      </div>
      <div class="felm-jelolok">
        <ion-toggle [(ngModel)]="urlap.oralatogatas_aloli" labelPlacement="end">
          Óralátogatás alól <small>(a naplóban nem írható be hiányzónak, a szülői órarendből eltűnik az óra)</small>
        </ion-toggle>
        <ion-toggle [(ngModel)]="urlap.ertekeles_aloli" labelPlacement="end">
          Értékelés alól <small>(nem kell osztályozni)</small>
        </ion-toggle>
        <ion-toggle [(ngModel)]="urlap.szovegesen_ertekelheto" labelPlacement="end">
          Szövegesen értékelhető
        </ion-toggle>
        <div class="felm-alcim">Kedvezmények <small>(nem mentesül, csak másképp kérik számon)</small></div>
        <ion-toggle [(ngModel)]="urlap.hosszabb_felkeszulesi_ido" labelPlacement="end">
          Hosszabb felkészülési idő
        </ion-toggle>
        <ion-toggle [(ngModel)]="urlap.irasbeli_helyett_szobeli" labelPlacement="end">
          Írásbeli helyett szóbeli számonkérés
        </ion-toggle>
        <ion-toggle [(ngModel)]="urlap.szobeli_helyett_irasbeli" labelPlacement="end">
          Szóbeli helyett írásbeli számonkérés
        </ion-toggle>
        <ion-toggle [(ngModel)]="urlap.kretaba" labelPlacement="end">
          A KRÉTÁ-ba is kerüljön ki <small>(visszaírásra vár)</small>
        </ion-toggle>
      </div>
      <div class="felm-gombsor">
        <ion-button size="small" (click)="ment()" [disabled]="mentes">
          <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
        </ion-button>
        <ion-button size="small" fill="clear" (click)="urlapNyitva = false">Mégsem</ion-button>
      </div>
    </div>

    <h4>Saját rögzítés</h4>
    <div style="overflow-x:auto" *ngIf="sajat.length; else nincsSajat">
      <table class="felm-tabla">
        <thead>
          <tr><th>Tanuló</th><th>Tantárgy</th><th>Időszak</th><th>Mi alól</th><th>Ok / határozat</th>
            <th>KRÉTA</th><th>Művelet</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let f of sajat" [class.torolt]="f.torolve">
            <td>{{ f.tanulo_nev || f.oktazon }}<br><small>{{ f.osztaly_nev }}</small></td>
            <td>{{ f.tantargy_nev || 'minden tantárgy' }}</td>
            <td>{{ f.kezdete || '—' }} – {{ f.vege || 'visszavonásig' }}</td>
            <td>{{ mentessegSzoveg(f) }}</td>
            <td>{{ f.ok || '–' }}<br><small>{{ f.hatarozat }}</small></td>
            <td>{{ allapotSzoveg(f) }}<br><small *ngIf="f.kreta_hiba" style="color:var(--ion-color-danger)">{{ f.kreta_hiba }}</small></td>
            <td class="felm-muvelet">
              <ion-button size="small" fill="outline" (click)="szerkeszt(f)" *ngIf="!f.torolve">Módosítás</ion-button>
              <ion-button size="small" fill="clear" color="danger" (click)="torol(f)" *ngIf="!f.torolve">Törlés</ion-button>
              <ion-badge color="medium" *ngIf="f.torolve">törölve</ion-badge>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #nincsSajat>
      <p style="font-size:.86rem; color:var(--ion-color-medium)">Még nincs saját rögzítésű felmentés.</p>
    </ng-template>

    <h4 style="margin-top:18px">
      A KRÉTÁ-ból behúzva
      <ion-button size="small" fill="outline" (click)="mindetAtvesz()" *ngIf="kreta.length">Mindet átveszem</ion-button>
    </h4>
    <p style="font-size:.82rem; color:var(--ion-color-medium); margin-top:0">
      Ezeket a KRÉTA-szinkron hozta. Itt csak olvashatók – az átvétellel a saját nyilvántartásba kerülnek,
      onnantól módosíthatók, és a szinkron nem írja felül őket.
    </p>
    <div style="overflow-x:auto" *ngIf="kreta.length; else nincsKreta">
      <table class="felm-tabla">
        <thead>
          <tr><th>Tanuló</th><th>Tantárgy</th><th>Időszak</th><th>Mi alól</th><th>Ok</th><th></th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let k of kreta">
            <td>{{ k.tanulo_nev }}<br><small>{{ k.kreta_osztaly }}</small></td>
            <td>{{ k.tantargy_nev }}</td>
            <td>{{ k.kezdete || '—' }} – {{ k.vege || 'visszavonásig' }}</td>
            <td>{{ mentessegSzoveg(k) }}</td>
            <td>{{ k.ok || '–' }}</td>
            <td class="felm-muvelet">
              <ion-button size="small" fill="outline" (click)="atvesz(k)"
                          [disabled]="!k.oktazon"
                          [title]="k.oktazon ? '' : 'A tanuló nincs párosítva – előbb a KRÉTA-szinkronnál kell rendezni'">
                Átveszem
              </ion-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #nincsKreta>
      <p style="font-size:.86rem; color:var(--ion-color-medium)">Nincs átvehető KRÉTA-felmentés.</p>
    </ng-template>

    <!--  VISSZAÍRÁS. A felmentés a KRÉTÁ-ban a tanulói adatlap „Felmentések" fülén van;
          oda írunk vissza. Előbb próbafutás (párosítás ellenőrzése), utána küldés. -->
    <h4 style="margin-top:18px">Visszaírás a KRÉTÁ-ba</h4>
    <p style="font-size:.85rem">
      Visszaírásra vár: <b>{{ visszairasraVar }}</b> tétel.
      <ion-button size="small" fill="clear" (click)="miMenneKi()">Mi menne ki?</ion-button>
      <ion-button size="small" fill="outline" (click)="probafutas()" [disabled]="kuldesFut || !visszairasraVar">
        <ion-icon slot="start" name="flask-outline"></ion-icon>Próbafutás
      </ion-button>
      <ion-button size="small" (click)="visszairas()" [disabled]="kuldesFut || !visszairasraVar">
        <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>Küldés a KRÉTÁ-ba
      </ion-button>
    </p>
    <p style="font-size:.8rem; color:var(--ion-color-medium); margin-top:0">
      A <b>próbafutás</b> belép a KRÉTÁ-ba, megkeresi a tanulót és a tantárgyat, és megmutatja a küldendő adatot –
      de nem küld. Érdemes vele kezdeni: a párosítás hiánya (más néven futó tantárgy, ismeretlen tanuló) így
      még a küldés előtt kiderül. Az <b>általános</b> (tantárgy nélküli) felmentést a KRÉTA nem fogadja.
    </p>

    <div *ngIf="kuldesEredmeny" class="felm-kuldendo">
      <p style="font-size:.85rem; margin-top:0">
        <b *ngIf="probafutasVolt">Próbafutás – nem küldtünk semmit. Ez menne ki:</b>
        <b *ngIf="!probafutasVolt && kuldesEredmeny.elkuldve !== undefined">
          Elküldve: {{ kuldesEredmeny.elkuldve }} · hiba: {{ kuldesEredmeny.hiba }} · kihagyva: {{ kuldesEredmeny.kihagyva }}
        </b>
        <span *ngIf="kuldesEredmeny.fiok"> — belépés: {{ kuldesEredmeny.fiok }} ({{ kuldesEredmeny.host }})</span>
      </p>
      <p *ngIf="kuldesEredmeny.hibauzenet" style="color:var(--ion-color-danger); font-size:.82rem">
        {{ kuldesEredmeny.hibauzenet }}
      </p>
      <div *ngFor="let t of kuldesEredmeny.tetelek" class="felm-kuldendo-tetel">
        <b>{{ t.tanulo }}</b> · {{ t.muvelet }}
        <ion-badge color="success" *ngIf="t.ok === true">elküldve</ion-badge>
        <ion-badge color="danger" *ngIf="t.ok === false">hiba</ion-badge>
        <ion-badge color="medium" *ngIf="t.probafutas">próbafutás</ion-badge>
        <div *ngIf="t.hianyzik?.length" style="color:var(--ion-color-danger); font-size:.8rem">
          Nem küldhető: {{ t.hianyzik.join('; ') }}
        </div>
        <div *ngIf="t.uzenet" style="font-size:.8rem">{{ t.uzenet }}</div>
        <pre *ngIf="t.torzs">{{ t.torzs | json }}</pre>
      </div>

      <!--  A KRÉTA visszakérdezése: a felmentés időszakára már van rögzített mulasztás. -->
      <div *ngIf="mulasztasKerdes" class="felm-mulasztas">
        <p>
          A KRÉTA jelezte, hogy az időszakra <b>már van rögzített mulasztás</b>, és a mentés átírná őket.
          Ez külön döntés, ezért magától nem tettük meg.
        </p>
        <ion-button size="small" color="warning" (click)="visszairas(true)" [disabled]="kuldesFut">
          Küldés a korábbi mulasztások átírásával
        </ion-button>
      </div>
    </div>

    <div *ngIf="kuldendo" class="felm-kuldendo">
      <p style="font-size:.82rem; margin-top:0">Ez menne ki (küldés nélkül):</p>
      <div *ngFor="let t of kuldendo.tetelek" class="felm-kuldendo-tetel">
        <b>{{ t.tanulo_nev }}</b> – {{ t.tantargy_nev || 'minden tantárgy' }} · {{ t.muvelet }}
        <div *ngIf="t.payload?.hianyzik?.length" style="color:var(--ion-color-danger); font-size:.8rem">
          Hiányzik: {{ t.payload.hianyzik.join('; ') }}
        </div>
        <pre>{{ t.payload?.vegpont }}
{{ t.payload?.torzs | json }}</pre>
      </div>
      <p *ngIf="!kuldendo.tetelek?.length" style="font-size:.85rem; color:var(--ion-color-medium)">
        Nincs visszaírásra váró tétel.
      </p>
    </div>

  </ion-card-content>
</ion-card>
